import * as client from "_graphql-types";
import * as types from "./types";

type Sdk = ReturnType<typeof client.getSdk>;

/*********************************************************************/
// Data Provider Functions
/*********************************************************************/

/*********************************************************************/
async function getList(sdk: Sdk, params: types.GetListParams<client.FinancialPeriodEnumSortEnum>) {
  const {
    pagination: { page, perPage },
    sort: { field, order }
  } = params;

  const {
    financialPeriodEnumList: { items: data, total }
  } = await sdk.getListFinancialPeriodEnum({
    page: {
      offset: (page - 1) * perPage,
      limit: perPage
    },
    sort: [{ field, order }]
  });

  return {
    data,
    total,
  };
}

/*********************************************************************/
async function getOne(sdk: Sdk, params: types.GetOneParams) {
  const id = Number(params.id);
  const { financialPeriodEnum: data } = await sdk.getOneFinancialPeriodEnum({
    id
  });
  return {
    data,
  };
}

/*********************************************************************/
async function getMany(sdk: Sdk, params: types.GetManyParams) {
  const ids = params.ids.map(Number);

  const {
    financialPeriodEnumMany: data
  } = await sdk.getManyFinancialPeriodEnum({
    ids
  });

  return {
    data,
  };
}


/*********************************************************************/
export const financialPeriodEnum = types.dataProvider({
  getList,
  getOne,
  getMany
});